import React, { lazy, Suspense, useEffect, useState } from 'react';
import Navbar from 'components/navbar';
import Footer from 'components/footer';
import WhatsAppButton from "components/WhatsAppButton";
import ScrollToTop from 'components/scroll-top';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'scss/abstract.scss';

// Cargar el CookieBanner de manera diferida
const CookieBanner = lazy(() => import('components/cookie-banner'));

const Layout = ({ children, isHome, sections }) => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  // Retrasar la carga del banner de cookies después de que todo el contenido se haya cargado
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent')
  
    if (!consent) {
      const handleLoad = () => {
        setShowCookieBanner(true)
      }
  
      if ('requestIdleCallback' in window) {
        requestIdleCallback(handleLoad)
      } else if (document.readyState === 'complete') {
        handleLoad()
      } else {
        window.addEventListener('load', handleLoad)
      }
  
      return () => {
        window.removeEventListener('load', handleLoad)
      }
    }
  }, [])

  return (
    <div id="main">
      <Navbar scroll={isHome} sections={sections} />
      {/* <PageRevealer /> */}
      <div>{children}</div>
      <Footer />

      {/* Cargar el CookieBanner de manera diferida y solo después del retraso */}
      {showCookieBanner && (
        <Suspense fallback={<div>Loading...</div>}>
          <CookieBanner />
        </Suspense>
      )}
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
};

export default Layout;
